import { BookingPricingModelType } from 'parkdepot-shared/gql/graphql'

// generateHourlyPriceQueryOptions.ts
export const generateHourlyPriceQueryOptions = (
    lotId: string,
    numHours: number,
    pricingType: BookingPricingModelType
): {
    variables: {
        lot_id: string
        num_hours: number
        pricing_type: BookingPricingModelType
    }
    fetchPolicy: 'no-cache'
} => ({
    variables: {
        lot_id: lotId.toUpperCase(),
        num_hours: numHours,
        pricing_type: pricingType
    },
    fetchPolicy: 'no-cache'
})
